import Folder from '../store/schema/Folder';
import getSelectedFolderId from './getSelectedFolderId';
import { getStore } from '../store/Store';

export default function getSelectedFolder(): Folder {
    const selectedFolderId = getSelectedFolderId();

    return !selectedFolderId ? null : getStore().folders.folderTable.get(selectedFolderId);
}
